import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React, { useEffect, useState } from "react"
import { ZoomedImageModal } from "./utils/zoomed-image-modal"
import { ZoomImageIcon } from "components/page-components/Icons/medium"
import { ArticleContentComponentContainer } from "../utils"

export const ImageZoomable = ({
  image,
  zoom_image,
  automatically_detected,
}) => {
  const image_data = getImage(image)
  const {
    fields: {
      caption,
      focus_point: { x, y },
    },
  } = image

  const [zoom_modal, set_zoom_modal] = useState(false)

  const toggle_zoom_image = () => {
    set_zoom_modal(!zoom_modal)
  }
  const close_modal = () => set_zoom_modal(false)

  useEffect(() => {
    window.addEventListener("scroll", close_modal)
    return () => {
      window.removeEventListener("scroll", close_modal)
    }
  }, []) //eslint-disable-line

  return (
    <React.Fragment>
      <ArticleContentComponentContainer>
        <div
          onClick={toggle_zoom_image}
          aria-label="Zoomable Image"
          role="button"
          tabIndex="-1"
          onKeyDown={toggle_zoom_image}
        >
          <figure className="is-marginless">
            <div className="zoom-img-wrapper" style={{ position: "relative" }}>
              <GatsbyImage
                image={image_data}
                alt={caption}
                title={caption}
                objectPosition={
                  !!x
                    ? `${Math.round(100 * x)}% ${Math.round(100 * y)}%`
                    : automatically_detected
                    ? "50% 20%"
                    : undefined
                }
                style={{ cursor: "zoom-in", maxHeight: 400 }}
                imgStyle={{ maxHeight: 400 }}
              />
              <div className="zoom-img-overlay"></div>
              <div
                style={{
                  position: "absolute",
                  right: 20,
                  top: 20,
                }}
              >
                <ZoomImageIcon {...{ size: 0.8 }} />
              </div>
            </div>
            <figcaption>{caption}</figcaption>
          </figure>
        </div>
      </ArticleContentComponentContainer>

      <ZoomedImageModal {...{ zoom_modal, set_zoom_modal, zoom_image }} />
    </React.Fragment>
  )
}
